










import { Vue, Component } from 'vue-property-decorator';
import { State } from 'vuex-class';
import DataLeft from './components/data-left.vue';
@Component({
  components: { DataLeft }
})
export default class Datas extends Vue {

  @State MENU_INDENT: any;
  
  update(key: string) {
    this.$router.push(key);
  }

}
